import {
  SET_APP_TITLE,
  SELECTION_DRAWER_TOGGLE,
  SET_APP_DECIMAL,
  SET_BANDED_ROWS,
  SET_DISABLE_CUSTOM_GROUP_SORT,
  SET_DISABLE_INTERSPERSE,
  SET_GRID_FONT_SIZE,
  SET_GRID_ROW_HEIGHT,
  SET_GRID_VERTICAL_LINES,
  SET_LISTEN_SCENARIO_APP_TALK,
  SET_LISTEN_ENTITY_GROUP_APP_TALK,
  SET_MIN_INCEPTION_DATE,
  SET_HIDE_GRID_SIDE_BAR,
  SET_GRID_HEADER_HEIGHT,
  SET_LOAD_DATA_ON_LAUNCH,
} from "./actions";
import { produce } from "immer";

// Hide the gridstate/columns sidebar if URL param hideGridBarOption is true.
// Setting it here prevents it showing during load.
const urlParams = new URLSearchParams(window.location.search);
const hideGridBarOption = urlParams.get("hideGridBarOption") === "true";

const defaultState = {
  selectionDrawerOpen: true,
  appDecimal: 3,
  appTitle: "Account Summary",
  minInceptionDate: null,
  disableCustomGroupSort: false,
  disableIntersperse: false,
  loadDataOnLaunch: true,
  bandedRows: true,
  gridVerticalLines: true,
  gridFontSize: 12,
  gridRowHeight: 22,
  gridHeaderHeight: 65,
  listenScenarioAppTalk: false,
  listenEntityGroupAppTalk: false,
  hideGridSideBar: hideGridBarOption ?? false,
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SELECTION_DRAWER_TOGGLE: {
      state.selectionDrawerOpen =
        action.override !== undefined
          ? action.override
          : !state.selectionDrawerOpen;
      break;
    }
    case SET_APP_DECIMAL: {
      state.appDecimal = action.appDecimal;
      break;
    }
    case SET_APP_TITLE: {
      state.appTitle = action.appTitle;
      break;
    }
    case SET_MIN_INCEPTION_DATE: {
      state.minInceptionDate = action.minInceptionDate;
      break;
    }
    case SET_DISABLE_CUSTOM_GROUP_SORT: {
      state.disableCustomGroupSort = action.disableCustomGroupSort;
      break;
    }
    case SET_DISABLE_INTERSPERSE: {
      state.disableIntersperse = action.disableIntersperse;
      break;
    }
    case SET_LOAD_DATA_ON_LAUNCH: {
      state.loadDataOnLaunch = action.payload;
      break;
    }
    case SET_BANDED_ROWS: {
      state.bandedRows = action.bandedRows;
      break;
    }
    case SET_GRID_VERTICAL_LINES: {
      state.gridVerticalLines = action.gridVerticalLines;
      break;
    }
    case SET_GRID_FONT_SIZE: {
      state.gridFontSize = action.gridFontSize;
      break;
    }
    case SET_GRID_ROW_HEIGHT: {
      state.gridRowHeight = action.gridRowHeight;
      break;
    }
    case SET_GRID_HEADER_HEIGHT: {
      state.gridHeaderHeight = action.gridHeaderHeight;
      break;
    }
    case SET_LISTEN_SCENARIO_APP_TALK: {
      state.listenScenarioAppTalk = action.value;
      break;
    }
    case SET_LISTEN_ENTITY_GROUP_APP_TALK: {
      state.listenEntityGroupAppTalk = action.value;
      break;
    }
    case SET_HIDE_GRID_SIDE_BAR: {
      state.hideGridSideBar = action.value;
      break;
    }

    default:
      return state;
  }
});

export default reducer;
